import React from 'react';
import { StripePricingTable } from './StripePricingTable';
import { Box, Container, Divider, Grid, Typography } from '@mui/material';

type PropTypes = {
  isAdmin: boolean;
};

export const PricingPage = ({ isAdmin }: PropTypes) => {
  return (
    <Container>
      {isAdmin ? (
        <Grid
          mt={8}
          container
          direction={'row'}
          flex={1}
          alignItems={'center'}
          justifyContent={'space-between'}
        >
          <Grid item sx={{ fontFamily: 'sans-serif' }} mr={8}>
            <Box
              boxSizing={'border-box'}
              flexDirection={'column'}
              alignItems={'center'}
              justifyContent={'flex-start'}
              p={4}
              sx={{ animationFillMode: 'forwards', animation: 'ease-in-out' }}
            >
              <Typography fontSize={20} sx={{ fontFamily: 'sans-serif' }}>
                Starter
              </Typography>
              <Typography
                fontSize={14}
                sx={{ fontFamily: 'sans-serif', opacity: 0.7 }}
              >
                Free, for trying things out.
              </Typography>
              <ul>
                <li>Unlimited Match Games</li>
                <li>Dailies</li>
                <li>Two solo games per day</li>
                <li>One pool game per day</li>
              </ul>
            </Box>
          </Grid>

          <Divider orientation="vertical" flexItem>
            <Typography textAlign="center">OR</Typography>
            <Typography textAlign="center">UPGRADE</Typography>
          </Divider>

          <Grid item flex={1}>
            <StripePricingTable />
          </Grid>
        </Grid>
      ) : (
        <Typography variant="subtitle1" textAlign={'center'} my={4}>
          You don't have permissions to view this page.
        </Typography>
      )}
    </Container>
  );
};
